require('Assets/Fontello/css/fontello-embedded');
